import { Component } from '@angular/core';
import {
  Router,
  RoutesRecognized,
  ActivatedRoute,
  NavigationEnd,
} from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { AuthService } from './services/auth.service';
import { filter, map, mergeMap } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  isShowNav: boolean = true;
isHomePage = false;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private metaService: Meta,
    private authService: AuthService
  ) {
    this.router.events.subscribe((event: any) => {
      if (event instanceof RoutesRecognized) {
        if (event.url == 'Signin') {
          this.isShowNav = false;
        } else {
          this.isShowNav = true;
        }
      }
    });

     this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.isHomePage =
          event.urlAfterRedirects === '/' ||
          event.urlAfterRedirects === '/home';
      });

  }

  ngOnInit(): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        filter((route) => route.outlet === 'primary'),
        mergeMap((route) => route.data)
      )
      .subscribe((data) => {
        // Update title dynamically
        if (data['title']) {
          this.titleService.setTitle(`${data['title']} | VinMarts.in`);
        } else {
          this.titleService.setTitle(
            'VinMarts.in - Online Shopping Site in India'
          );
        }

        // Update meta tags dynamically
        if (data['description']) {
          this.metaService.updateTag({
            name: 'description',
            content: data['description'],
          });
        }
        if (data['keywords']) {
          this.metaService.updateTag({
            name: 'keywords',
            content: data['keywords'],
          });
        }

        // Update canonical URL dynamically
        const canonicalUrl = data['canonicalUrl']
          ? `https://www.vinmarts.in/${data['canonicalUrl']}`
          : 'https://www.vinmarts.in/';
        this.metaService.addTag({ rel: 'canonical', href: canonicalUrl });
      });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // One immediate reset avoids scheduling two simultaneous smooth-scroll
        // animations for every route change.
        window.scrollTo({ top: 0, behavior: 'auto' });
      }
    });
  }

  closeMenuFromMainPage(): void {
    this.authService.closeSideMenu(); // Notify the shared service to close the side menu
  }
}
